import StickyBox from './StickyBox';

export default StickyBox;
